import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { ITenant, IUserRoleAccess } from "ui/shared/models/common";

import { IUserState, UserStateErrors, IIdentity, getInitialUserState, IRole } from "./UserProvider.state";

export const user = createSlice({
  name: "user",
  initialState: getInitialUserState(),
  reducers: {
    trySignIn: (state: IUserState) => {
      return {
        ...state,
        error: undefined,
        identity: undefined,
        isAuthenticated: false,
        authenticationProcessing: true
      };
    },
    remoteAuthenticationRequired: (state: IUserState) => {
      return {
        ...state,
        error: undefined,
        identity: undefined,
        isAuthenticated: false,
        authenticationProcessing: false,
        remoteAuthenticationRequired: true
      };
    },
    signIn: (state: IUserState) => {
      return {
        ...state,
        error: undefined,
        identity: undefined,
        isAuthenticated: false,
        authenticationProcessing: true
      };
    },
    completeSignIn: (state: IUserState) => {
      return {
        ...state,
        error: undefined,
        identity: undefined,
        isAuthenticated: false,
        authenticationProcessing: true
      };
    },
    signInCompleted: (state: IUserState, action: PayloadAction<IIdentity>) => {
      return {
        ...state,
        identity: action.payload,
        isAuthenticated: true,
        authenticationProcessing: false,
        remoteAuthenticationRequired: false
      };
    },
    signOut: () => {
      return {
        ...getInitialUserState(),
        signOutProcessing: true
      };
    },
    signInError: (state: IUserState) => {
      return {
        ...state,
        identity: undefined,
        error: UserStateErrors.SignInFailed,
        authenticationProcessing: false
      };
    },
    authorize: (state: IUserState) => {
      return {
        ...state,
        authorizationProcessing: true,
        roles: [],
        tenants: [],
        isAuthorized: false
      };
    },
    authorizeCompleted: (state: IUserState, action: PayloadAction<{ roles: IRole[]; tenants: ITenant[]; userRoleAccessData: IUserRoleAccess }>) => {
      return {
        ...state,
        roles: action.payload.roles,
        tenants: action.payload.tenants,
        isAuthorized: true,
        authorizationProcessing: false,
        userRoleAccessData: action.payload.userRoleAccessData
      };
    },
    authorizeError: (state: IUserState) => {
      return {
        ...state,
        error: UserStateErrors.AuthorizationFailed,
        roles: [],
        tenants: [],
        isAuthorized: false,
        authorizationProcessing: false
      };
    },
    invalidSession: (state: IUserState) => {
      return {
        ...state,
        error: UserStateErrors.InvalidSession,
        roles: [],
        tenants: [],
        isAuthorized: false,
        isAuthenticated: false,
        identity: undefined
      };
    },
    tenantChanged: (state: IUserState, action: PayloadAction<{ tenantId: string; userRoleAccessData: IUserRoleAccess }>) => {
      return {
        ...state,
        identity: state.identity && { ...state.identity, tenantId: action.payload.tenantId },
        userRoleAccessData: action.payload.userRoleAccessData
      };
    },
    changeUserRoleAccessData: (state: IUserState, action: PayloadAction<IUserRoleAccess>) => {
      return {
        ...state,
        userRoleAccessData: action.payload
      };
    }
  }
});
